import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import AdminLayout from "components/admin/layout"
import isUserA from "components/users/is-a"
import memo from "set-state-compare/build/memo"
import React from "react"
import setLayout from "shared/set-layout"
import useCurrentUser from "@kaspernj/api-maker/build/use-current-user"

const RoutesAdminDashboard = React.lazy(() => import("routes/admin/dashboard-route"))
const RoutesUserDashboard = React.lazy(() => import("routes/user/dashboard-route"))

export default memo(shapeComponent(class RoutesFrontWelcome extends ShapeComponent {
  render() {
    setLayout("front")

    const currentUser = useCurrentUser()

    if (isUserA(currentUser, ["admin", "hacker", "sales_rep"])) {
      return (
        <AdminLayout>
          <RoutesAdminDashboard />
        </AdminLayout>
      )
    } else {
      return (
        <RoutesUserDashboard dataSet={this.frontLayoutDataSet ||= {route: "front/welcome"}} redirectAfterSignIn />
      )
    }
  }
}))
